module.exports = __webpack_public_path__ + "static/media/search.bcc4feea.svg";